import selectInsurance from 'utils/selectInsurance';

const getInsuranceSignatureOnFile = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  return selectedInsurance && selectedInsurance['Signature On File'] === false
    ? null : 'SOF';
};

export default getInsuranceSignatureOnFile;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceSignatureOnFile.js